export default __webpack_public_path__ + "static/subnav-wine-finder-08930d0124c4fed3acfd89243e1c3896.png";